import { honeyVestingContract } from "config";
import { BigNumber } from "ethers";
import { NftVestingStats } from "types";
import { useContractRead } from "wagmi";

const useBearVestingStats = (
  tokenId?: number | string | BigNumber
): [NftVestingStats | undefined, () => void] => {
  const [{ data: statsData }, readBearStats] = useContractRead(
    {
      addressOrName: honeyVestingContract.address,
      contractInterface: honeyVestingContract.interface,
    },
    "getBearStats",
    {
      args: tokenId && [tokenId, Math.floor(Date.now() / 1000 - 10000)],
    }
  );

  return [statsData as NftVestingStats | undefined, readBearStats];
};

export default useBearVestingStats;
